/* Monte sua rotina (sections/mv2-rotina.liquid): tamanho, escolha por passo, resumo, barra fixa e compra. */
(function () {
  var root = document.querySelector('[data-rot]');
  if (!root) return;

  var PARC = 1.22676 / 12;   /* fator da casa para 12x no cartão */
  var tams = [];
  try { tams = JSON.parse(root.dataset.tams || '[]'); } catch (e) {}
  var frete = +root.dataset.frete || 0;
  var size = +root.dataset.padrao || 1;
  var sel = {};   /* id do passo -> produto escolhido */

  var steps = [].slice.call(root.querySelectorAll('[data-step]'));
  var tamBtns = [].slice.call(root.querySelectorAll('[data-tam]'));
  var buyBtn = root.querySelector('[data-buy]');
  var msg = root.querySelector('[data-msg]');
  var bar = root.querySelector('[data-bar]');
  var barBtn = root.querySelector('[data-bar-btn]');
  var resumo = root.querySelector('.mv2r-sum');

  function money(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function visivel(s) { return +s.dataset.desde <= size; }
  function tam() { return tams[size - 1] || { nome: '' }; }

  function estado() {
    var need = 0, have = 0, sub = 0, items = [], pendente = null;
    steps.forEach(function (s) {
      if (!visivel(s)) return;
      need++;
      var x = sel[s.dataset.step];
      if (x) {
        have++;
        sub += x.price;
        items.push(x);
      } else if (!pendente) {
        pendente = s;
      }
    });
    return { need: need, have: have, sub: sub, total: sub, items: items, pendente: pendente, ok: need > 0 && have === need };
  }

  function render() {
    tamBtns.forEach(function (b) {
      var on = +b.dataset.tam === size;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var n = 2;
    steps.forEach(function (s) {
      var v = visivel(s);
      s.hidden = !v;
      var li = root.querySelector('[data-sum-step="' + s.dataset.step + '"]');
      if (li) li.hidden = !v;
      if (!v) return;
      var num = s.querySelector('[data-num]');
      if (num) num.textContent = n++;
      var x = sel[s.dataset.step];
      s.classList.toggle('is-done', !!x);
      if (li) {
        li.classList.toggle('is-done', !!x);
        li.querySelector('[data-v]').innerHTML = x
          ? (x.img ? '<img src="' + esc(x.img) + '" alt="" width="34" height="34" loading="lazy">' : '') +
            '<em>' + esc(x.nome) + (x.var ? '<small>' + esc(x.var) + '</small>' : '') + '</em><b>' + money(x.price) + '</b>'
          : 'Aguardando seleção';
      }
    });

    var e = estado(), t = tam();
    root.querySelector('[data-sub]').textContent = money(e.sub);
    var total = e.ok ? e.total : e.sub;
    root.querySelector('[data-total]').textContent = money(total);
    root.querySelector('[data-parc]').textContent = 'ou 12x de ' + money(total * PARC);
    var fm = root.querySelector('[data-frete-msg]');
    if (fm) fm.hidden = !(frete > 0 && e.ok && total >= frete);

    buyBtn.disabled = !e.ok;
    var falta = e.need - e.have;
    msg.textContent = e.ok
      ? 'Sua rotina está pronta para finalizar.'
      : (falta === 1 ? 'Falta escolher 1 produto.' : 'Faltam ' + falta + ' produtos para completar a ' + t.nome + '.');

    if (bar) {
      bar.querySelector('[data-bar-k]').textContent = e.ok ? t.nome : e.have + ' de ' + e.need + ' produtos escolhidos';
      bar.querySelector('[data-bar-total]').textContent = money(total);
      barBtn.textContent = e.ok ? 'Comprar' : 'Próximo passo';
    }
    return e;
  }

  /* passo com um único produto disponível já vem escolhido */
  function autoEscolhe() {
    steps.forEach(function (s) {
      if (sel[s.dataset.step]) return;
      var livres = [].slice.call(s.querySelectorAll('[data-pick]:not([disabled])'));
      if (livres.length === 1) escolhe(s, livres[0], true);
    });
  }

  function escolhe(s, btn, silencioso) {
    var id = s.dataset.step;
    var ja = sel[id] && sel[id].id === +btn.dataset.id;
    s.querySelectorAll('[data-pick]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    if (ja && !silencioso) {
      delete sel[id];
    } else {
      btn.setAttribute('aria-pressed', 'true');
      sel[id] = { id: +btn.dataset.id, price: +btn.dataset.price, nome: btn.dataset.nome, var: btn.dataset.var, img: btn.dataset.img };
    }
  }

  tamBtns.forEach(function (b) {
    b.addEventListener('click', function () { size = +b.dataset.tam; render(); });
  });
  steps.forEach(function (s) {
    s.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        escolhe(s, b);
        render();
      });
    });
  });

  /* ── compra ── */
  var cartFlow = window.MaxfemCartFlow || {
    directCheckout: true,
    labels: { checkout: 'Indo para o pagamento...' },
    finishPurchase: function () { window.location.href = '/checkout?locale=pt-BR'; }
  };
  var comprando = false;
  function comprar() {
    var e = estado();
    if (!e.ok || comprando) return;
    var items = e.items.map(function (x) { return { id: x.id, quantity: 1 }; });
    var permalink = '/cart/' + items.map(function (i) { return i.id + ':1'; }).join(',');
    comprando = true;
    buyBtn.disabled = true;
    var label = buyBtn.textContent;
    var purchaseError = '';
    buyBtn.textContent = cartFlow.labels[cartFlow.directCheckout ? 'checkout' : 'adding'];
    if (window.gtag) gtag('event', cartFlow.directCheckout ? 'begin_checkout' : 'add_to_cart', { currency: 'BRL', value: e.total / 100, item_list_name: 'monte-sua-rotina', item_variant: t.nome });

    /* _section_store_cart=1: sem a marca o app do carrinho abre a gaveta por cima */
    fetch('/cart/add.js?_section_store_cart=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
    }).then(function () {
      return cartFlow.finishPurchase();
    }).catch(function () {
      if (cartFlow.directCheckout) window.location.href = permalink;
      else purchaseError = cartFlow.labels.error;
    }).finally(function () {
      comprando = false;
      buyBtn.textContent = label;
      render();
      if (purchaseError) msg.textContent = purchaseError;
    });
  }
  buyBtn.addEventListener('click', comprar);

  /* ── barra fixa do celular: aparece depois do topo e some quando o resumo está na tela ── */
  if (bar) {
    var main = root.querySelector('.mv2r-main');
    var checa = function () {
      var m = main.getBoundingClientRect(), r = resumo.getBoundingClientRect();
      var dentro = m.top < window.innerHeight * 0.6 && m.bottom > 120;
      var resumoNaTela = r.top < window.innerHeight - 80 && r.bottom > 0;
      var on = dentro && !resumoNaTela;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      barBtn.tabIndex = on ? 0 : -1;
    };
    var raf;
    window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(checa); }, { passive: true });
    window.addEventListener('resize', checa);
    barBtn.addEventListener('click', function () {
      var e = estado();
      if (e.ok) { comprar(); return; }
      var alvo = e.pendente || resumo;
      alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    checa();
  }

  autoEscolhe();
  render();
})();
